module.exports = __webpack_public_path__ + "img/img33.25fd777b.png";